import { movieCatalog } from '@/mocks/movies';
import type { Movie } from '@/pages/home/types';
import SectionHeading from '@/pages/home/components/SectionHeading';

interface TvSectionProps {
  onPickGenre: (genre: string) => void;
}

export default function TvSection({ onPickGenre }: TvSectionProps) {
  const series = (movieCatalog as Movie[]).filter((m) => m.kind === 'tv');

  return (
    <section id="tv" className="bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="剧集精选"
          title="555电影电视剧：在播与口碑剧集一览"
          desc="剧集分区按题材整理了长篇与单元剧，标注集数、地区与标签，方便你按追剧节奏挑选。以下内容均可在片库检索中继续按类型筛选。"
        />

        <div className="mt-10 flex flex-col gap-4">
          {series.map((m) => (
            <article
              key={m.id}
              className="group flex flex-col gap-4 rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-300 sm:flex-row md:p-5"
            >
              <div className="h-52 w-full shrink-0 overflow-hidden rounded-md bg-background-200 sm:h-44 sm:w-32">
                <img
                  src={m.poster}
                  alt={`${m.title} 海报`}
                  title={`${m.title} - 555电影电视剧`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col gap-3">
                <div className="flex flex-wrap items-center gap-3">
                  <span className="rounded-md bg-accent-100 px-2 py-1 text-xs font-medium text-accent-700">
                    剧集
                  </span>
                  <span className="rounded-md bg-primary-500 px-2 py-1 text-xs font-medium text-background-50">
                    {m.rating} 分
                  </span>
                  <span className="text-xs text-foreground-500">
                    {m.region} · {m.year} · {m.duration}
                  </span>
                </div>
                <h3 className="font-heading text-lg font-bold text-foreground-950">{m.title}</h3>
                <p className="text-sm leading-relaxed text-foreground-600">{m.blurb}</p>
                <div className="flex flex-wrap items-center gap-2">
                  <button
                    type="button"
                    onClick={() => onPickGenre(m.genre)}
                    className="cursor-pointer rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900 transition-colors hover:bg-secondary-200"
                  >
                    {m.genre}
                  </button>
                  {m.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-background-200 px-3 py-1 text-xs text-foreground-700"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}